import MAppBar from './AppBar.vue';

export { MAppBar };
export default MAppBar;
